module.exports = __webpack_public_path__ + "img/zaeune.5f77be2b.jpg";